import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';
import { RemoteSubmit } from '@saucelabs/sl-component-form';

import SetGroupConcurrencyForm, { name } from './SetGroupConcurrencyForm';
import Styles from './SetGroupConcurrencyModal.styles';

class SetGroupConcurrencyModal extends Component {
  shouldComponentUpdate(nextProps) {
    const { show } = this.props;
    return show !== nextProps.show || nextProps.show;
  }

  render() {
    const {
      currentVM,
      handleSubmit,
      maxVM,
      onHide,
      show,
    } = this.props;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Adjust Concurrency for all Teams</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Note: Groups do not have concurrency allocations. Concurrency is
            set on a team level. Setting Concurrency sets the concurrency for
            the teams in the group.
          </p>
          <p>
            You are about to change the concurrency for all teams inside
            this group. Groups themselves do not have concurrency, as concurrency
            is managed by team.
          </p>
          <h5 className={Styles['section-header']}>Virtual Machines</h5>
          <SetGroupConcurrencyForm
            currentVM={currentVM || 0}
            initialValues={{ virtual_machines: currentVM }}
            maxVM={maxVM}
            setConcurrency={(data) => handleSubmit(data).then(onHide)}
          />
          <ul className={Styles['extra-info']}>
            <li>
              {'Org. Max: '}
              {maxVM}
            </li>
            <li>
              {'Previous: '}
              {currentVM || 'None'}
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
          <RemoteSubmit
            category="primary"
            material
            name={name}
            size="sm"
          >
            Save
          </RemoteSubmit>
        </Modal.Footer>
      </Modal>
    );
  }
}

SetGroupConcurrencyModal.propTypes = {
  currentVM: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  maxVM: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(name, SetGroupConcurrencyModal);
export { name, SetGroupConcurrencyModal };
